import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Service for managing application error state.
 * Provides a centralized way to display and clear error messages.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private readonly _error = new BehaviorSubject<string | null>(null);

  /**
   * Observable stream of the current error message.
   * Emits null when there is no error.
   */
  get error$(): Observable<string | null> {
    return this._error.asObservable();
  }

  /**
   * Get the current error message synchronously.
   */
  get currentError(): string | null {
    return this._error.getValue();
  }

  /**
   * Display an error message to the user.
   */
  showError(message: string): void {
    this._error.next(message);
  }

  /**
   * Clear the current error message.
   */
  clearError(): void {
    this._error.next(null);
  }
}
